import * as bg02 from '../actions/bg02.actions';
import * as moment from 'moment';
export interface State {
  page_content: any;
}
export const initialState = {
    page_content: {}
};

export function reducer(state = initialState, action: bg02.Actions) {
  switch (action.type) {
    case bg02.GO_TO_PAGE_BG02: {
      const data = transformResponse(action.payload);
      return Object.assign({}, state, {
        ...state,
        raw_data: action.payload,
        page_content: {
          data: data.data,
          noOfRecords: data.noOfRecords
        }
      });
    }

    default:
      return state;
  }
}

function transformResponse(data) {
  try {
    // console.log(data.pagesAllowed);
    // const canRedirect = data.pagesAllowed.find(page => page.functionName === 'Redirection of Future Investment Contribution') === -1 ? 'N' : 'Y';
    // const canSwitch = data.pagesAllowed.find(page => page.functionName === 'Switching') === -1 ? 'N' : 'Y';
    return {
      noOfRecords: data.data['noOfRecords'],
      data: data.data.policyEnquiry.map(e => {
        return {
          BG02_16: e['policyNo'],
          BG02_17: e['ownerName'],
          BG02_18: e['productName'],
          // Fixed workitem 531
          // BG02_19: moment(e['policyIssueDate']).format('YYYY-MM-DD'),
          BG02_19: e['policyProposalReceivedDate'],
          // BG02_20: moment(e['policyInceptionDate']).format('YYYY-MM-DD'),
          BG02_20: moment(e['policyInceptionDate']).format('DD/MM/YYYY'),
          BG02_21: e['policyCurrency'],
          BG02_22: e['totalPremiumAmount'],
          BG02_23: e['policyPaymentMode'],
          // Fixed Bug #318
          // BG02_24: e['brokerName'],
          BG02_24: e['trName'],
          BG02_25: e['hasAdviserFlag'],
          BG02_26: e['eStatementFlag'],
          // Fixed workitem 364
          BG02_27: e['fundSwitchFlag2'],
          BG02_28: e['fundRedirectionFlag2'],
          BG03_28: e['policyProposalReceivedDate'],
          BG03_29: e['totalPremiumAmount'],
        };
      })
    };
  } catch (err) {
    console.log(err);
    return {
      noOfRecords: 0,
      data: []
    };
  }
}
